import { store } from '@/store'
import { SetupGuideEnum } from '@/enums/modules/routes'
import Integrations from '@/services/integrations/RegisterIntegration'
import IntegrationsEnum from '@/enums/modules/integrations'
import { handleRedirect } from '@/utils/redirect'
import { login, refreshToken, clearUser } from '@/auth/authHandler'

// Components to load
const SignUp = () => import(/* webpackChunkName: "SignUp" */ '@/components/setupGuide/SignUp')
const Login = () => import(/* webpackChunkName: "Login" */ '@/components/setupGuide/Login')
const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */ '@/components/setupGuide/ForgotPassword')
const ResetYourPassword = () => import(/* webpackChunkName: "ResetYourPassword" */ '@/components/setupGuide/ResetYourPassword')
const CheckYourEmail = () => import(/* webpackChunkName: "CheckYourEmail" */ '@/components/setupGuide/CheckYourEmail')
const FreeAccount = () => import(/* */ '@/components/setupGuide/FreeAccount')
const Initialize = () => import(/* webpackChunkName: "Initialize" */ '@/components/setupGuide/Initialize')
const Logout = () => import(/* webpackChunkName: "Logout" */ '@/components/setupGuide/Logout')

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

const allowedAutoLinkSources = [IntegrationsEnum.shopify, IntegrationsEnum.amazon]

export default [
  {
    path: '/SignUp',
    name: SetupGuideEnum.SignUp,
    component: SignUp,
    beforeEnter: async (to, from, next) => {
      const { type, code, store: storeName } = to.query
      if (type && code && storeName && allowedAutoLinkSources.includes(type)) {
        const signedIn = await store.dispatch('authenticate')
        if (signedIn) {
          // registerIntegrationStore returns null on successful link
          const resRegister = await Integrations.registerIntegrationStore(type, code, storeName)
          if (resRegister && resRegister.length > 0) {
            // trigger error in store link
            return next({ name: SetupGuideEnum.SignUp, query: { type, error: 1 } })
          } else {
            return handleRedirect(to, true)
          }
        }
      }
      next()
    }
  },
  {
    path: '/SignUp/:token/:email',
    name: SetupGuideEnum.SignUpWithToken,
    component: SignUp,
    props: true
  },
  {
    path: '/SignUp/PreLaunch',
    name: SetupGuideEnum.SignUpPreLaunch,
    beforeEnter (to, from, next) {
      store.dispatch('user/setPreLaunchUser', true)
      document.cookie = 'ShipbobSignupType=preLaunch; path=/;'
      next(SetupGuideEnum.SignUp)
    }
  },
  {
    path: '/Login',
    name: SetupGuideEnum.Login,
    component: Login,
    beforeEnter: async (to, from, next) => {
      await login(to)
      next()
    }
  },
  {
    path: '/ForgotPassword',
    name: SetupGuideEnum.ForgotPassword,
    component: ForgotPassword,
    props: (route) => ({
      source: route.query.source
    })
  },
  {
    path: '/NewPassword/:email/:token',
    name: SetupGuideEnum.ResetYourPassword,
    component: ResetYourPassword,
    props: (route) => {
      return {
        source: route.query.source,
        email: route.params.email,
        token: route.params.token
      }
    }
  },
  {
    path: '/SendPassword',
    name: SetupGuideEnum.CheckYourEmail,
    component: CheckYourEmail
  },
  {
    path: '/FreeAccount',
    name: SetupGuideEnum.FreeAccount,
    component: FreeAccount
  },
  {
    path: '/Initialize', 
    name: SetupGuideEnum.Initialize,
    component: Initialize,
    props: (route) => ({
      source: route.query.source
    })
  },
  {
    path: '/Logout',
    name: SetupGuideEnum.Logout,
    component: Logout
  },
  {
    path: '/Refresh',
    name: SetupGuideEnum.Refresh,
    beforeEnter: async (to, from, next) => {
      const successfulRefresh = await refreshToken()
      if (!successfulRefresh) {
        await clearUser()
        next({ name: SetupGuideEnum.Login, query: to.query })
        return
      }

      const { ReturnUrl } = to.query
      if (ReturnUrl) {
        window.location.replace(ReturnUrl)
      } else {
        next({ name: 'Dashboard' })
      }
    }
  }
]
